import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Hash, ArrowUpRight, CreditCard, ShieldCheck, Check } from "lucide-react";
import { Logo } from "./Logo";

const KEY = "jackcash-onboarded";

const SLIDES = [
  { icon: Hash, title: "Your Cash Tag is your @", body: "Share your unique $Cash Tag so anyone can pay you in seconds — no account numbers needed.", color: "#6B3BF5" },
  { icon: ArrowUpRight, title: "Send & receive instantly", body: "Move money to friends, split a bill, or request a payment. It lands in the wallet right away.", color: "#4B23CC" },
  { icon: CreditCard, title: "Add money & cards", body: "Top up by card, spend with a virtual or physical card, save toward goals and convert USD ⇄ HTG.", color: "#2b1570" },
  { icon: ShieldCheck, title: "Protected 24/7", body: "Turn on Account Guard for AI fraud monitoring, and reach a real human in support anytime.", color: "#5a2fd6" },
];

export function Onboarding() {
  const nav = useNavigate();
  const [open, setOpen] = useState(() => {
    try { return localStorage.getItem(KEY) !== "1"; } catch { return false; }
  });
  const [i, setI] = useState(0);

  if (!open) return null;

  const finish = (go) => {
    try { localStorage.setItem(KEY, "1"); } catch {}
    setOpen(false);
    if (go) nav(go);
  };

  const slide = SLIDES[i];
  const last = i === SLIDES.length - 1;

  return (
    <div className="fixed inset-0 z-[80] bg-background flex justify-center" data-testid="onboarding">
      <div className="w-full max-w-md lg:max-w-lg flex flex-col h-full px-6 py-8">
        <div className="flex items-center justify-between">
          <Logo size={30} />
          <button data-testid="onboarding-skip" onClick={() => finish(null)} className="text-sm font-semibold text-muted-foreground">Skip</button>
        </div>

        <div className="flex-1 flex flex-col items-center justify-center text-center">
          <div className="w-28 h-28 rounded-[2rem] grid place-items-center mb-8 shadow-xl" style={{ background: `linear-gradient(145deg, ${slide.color}, #1b0e3f)` }}>
            <slide.icon size={48} className="text-white" strokeWidth={1.8} />
          </div>
          <h1 className="font-display text-3xl font-bold max-w-xs">{slide.title}</h1>
          <p className="text-muted-foreground mt-3 max-w-xs">{slide.body}</p>
        </div>

        <div className="flex items-center justify-center gap-2 mb-6">
          {SLIDES.map((_, idx) => (
            <span key={idx} className={`h-2 rounded-full transition-all duration-300 ${idx === i ? "w-6 bg-primary" : "w-2 bg-muted"}`} />
          ))}
        </div>

        {last ? (
          <div className="space-y-3">
            <button data-testid="onboarding-start" onClick={() => finish("/app/send")}
              className="w-full h-14 rounded-2xl bg-primary text-primary-foreground font-semibold flex items-center justify-center gap-2">
              <Check size={18} /> Start sending money
            </button>
            <button data-testid="onboarding-explore" onClick={() => finish(null)}
              className="w-full h-12 rounded-2xl bg-secondary font-semibold text-sm">Explore on my own</button>
          </div>
        ) : (
          <button data-testid="onboarding-next" onClick={() => setI(i + 1)}
            className="w-full h-14 rounded-2xl bg-primary text-primary-foreground font-semibold flex items-center justify-center gap-2">
            Next <ArrowRight size={18} />
          </button>
        )}
      </div>
    </div>
  );
}
